<template>
  <div>
    <v-btn
      flat
      @click="$router.go(-1)">
      <v-icon dark>chevron_left</v-icon>
      Properties      
    </v-btn>
    <v-toolbar flat>
      <v-toolbar-title>{{currentProperty}} Expenses</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details>
      </v-text-field> -->
      <v-tooltip bottom>
        <v-btn @click="AddRecord" slot="activator" color="primary" dark class="mb-2">Add Expense</v-btn>
        <span>Add a New Expense</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table flat :headers="headers" :items="recordList" :search="search" class="elevation-1" hide-actions>
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.data().date }}</td>
        <td class="text-xs-left">{{ props.item.data().amount | usd(2) }}</td>
        <td class="text-xs-left">{{ props.item.data().description }}</td>
        <td class="text-xs-left">{{ props.item.data().category }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip bottom>
            <v-icon @click="View(props.item)" slot="activator" small class="mt-3 mr-2">
              edit
            </v-icon>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon @click="ConfirmDelete(props.item)" slot="activator" small class="mt-3 mr-2">
              delete
            </v-icon>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        NO EXPENSES FOUND
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form ref="form">
      <v-card>
        <v-card-title>
          <span class="headline">Expense</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="date"
                      v-model="modalRecord.date"
                      label="Expense Date"
                      required 
                      :rules="[() => !!modalRecord.date || 'This field is required']"
                      readonly
                      box
                      v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="modalRecord.date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field ref="amount" v-model="modalRecord.amount" type="number" maxlength="10" required :rules="[() => !!modalRecord.amount || 'This field is required']" label="Amount" box @focus="$event.target.select()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field ref="description" v-model="modalRecord.description" maxlength="50" required :rules="[() => !!modalRecord.description || 'This field is required']" label="Description" box @focus="$event.target.select()"></v-text-field>
              </v-flex>
              <v-flex xs12 d-flex>
                <v-select
                  ref="category"
                  :items="categories"
                  v-model="modalRecord.category"
                  required
                  :rules="[() => !!modalRecord.category || 'This field is required']"
                  box
                  label="Expense Category"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="CancelSave()">Cancel</v-btn>
          <v-btn color="primary" v-if="this.modalRecord.id === ''" @click="CreateRecord()">Add Expense</v-btn>
          <v-btn color="primary" v-if="this.modalRecord.id !== ''" @click="UpdateRecord()">Update Expense</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="confirmDelete" persistent max-width="325">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Delete Expense?
        </v-card-title>
        <v-card-text>
          <b>Please confirm to delete this expense.</b><br/>
          This action cannot undone.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="DeleteRecord">
            DELETE
          </v-btn>
          <v-btn color="primary" @click="confirmDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import db from '../../firebaseInit';

  export default {
    name: 'ExpenseList',
    data() {
      return {
        dialog: false,
        confirmDelete: false,
        recordToDelete: "",
        alert: false,
        search: "",
        menu2: false,
        date: new Date().toISOString().substr(0, 10),
        formHasErrors: false,
        recordList: [
          {
            propertyId: "",
            date: new Date().toJSON(),
            amount: 233.19,
            description: "Furnace Repair",
            category: "Repair",
            id: ""
          }
        ],
        modalRecord:
        {
          date: "",
          amount: "",
          description: "",
          category: "",
          id: ""
        },
        headers: [
          { text: 'Date', value: 'date', sortable: false },
          { text: 'Amount', value: 'amount', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: 'Category', value: 'category', sortable: false },
          { text: 'Actions', align: 'center', sortable: false  }
        ],
        categories: ['Repairs', 'Maintenance', 'Management', 'CapEx']
      }
    },
    methods: {
      GetRecords(){
        db.collection("expenses").where("propertyId", "==", this.propertyId).orderBy("date").get().then((querySnapshot) => {
          this.recordList = querySnapshot.docs;  
        });
      },
      View(item) {
        this.$refs.form.reset();
        this.dialog=true;
        this.$nextTick(() => {
          this.modalRecord = {
            date: item.data().date,
            amount: item.data().amount,
            description: item.data().description,
            category: item.data().category,
            id: item.id
          };
          console.log(this.modalRecord);
          this.$refs.amount.focus();
        });
      },
      AddRecord(){
        this.$refs.form.reset();
        this.dialog=true;
        this.$nextTick(() => {
          this.modalRecord = {
            date: new Date().toISOString().substr(0, 10), //default to today
            amount: "",
            description: "",
            category: "",
            id: ""
          };
          this.$refs.amount.focus();
        });
      },
      CreateRecord(){
        var that = this; //preserve reference before promise call
        this.formHasErrors = false
        if (!this.$refs.form.validate()) {
          return;
        }

        // Add a new document with a generated id.
        db.collection("expenses").add({
            propertyId: this.propertyId,
            date: this.modalRecord.date,
            amount: this.modalRecord.amount,
            description: this.modalRecord.description,
            category: this.modalRecord.category
        }).then(function(docRef) {
            console.log("Document written with ID: ", docRef.id);
            that.$nextTick(() => {
              that.GetRecords();
            });

            if (!that.formHasErrors)
              that.dialog = false;

        }).catch(function(error) {
            console.error("Error adding document: ", error);
        });
      },
      UpdateRecord(){
        var that = this; //preserve reference before promise call
        this.formHasErrors = false
        if (!this.$refs.form.validate()) {
          return;
        }

        // Add a new document with a generated id.
        db.collection("expenses").doc(this.modalRecord.id).set({
            propertyId: this.propertyId,
            date: this.modalRecord.date,
            amount: this.modalRecord.amount,
            description: this.modalRecord.description,
            category: this.modalRecord.category
        }).then(function() {
            console.log("Document updated with ID: ", that.modalRecord.id);
            that.$nextTick(() => {
              that.GetRecords();
            });

            if (!that.formHasErrors)
              that.dialog = false;
        }).catch(function(error) {
            console.error("Error updating document: ", error);
        });
      },
      CancelSave(){
        this.dialog = false;
        this.formHasErrors = false;
      },
      ConfirmDelete(item){
        this.recordToDelete = item.id;
        this.confirmDelete=true;
      },
      DeleteRecord(){
        var that = this; //preserve reference before promise call
        var id = this.recordToDelete;
        console.log("delete - " + id);
        db.collection("expenses").doc(id).delete().then(function() {
          console.log("Document " + id + " successfully deleted!");

          that.$nextTick(() => {
            that.GetRecords();
          });

          that.confirmDelete = false;
        }).catch(function(error) {
          console.error("Error removing document: ", error);
        });
      },
    },
    computed: {
      propertyId(){
        return this.$route.params.id;
      },
      currentProperty(){
        return this.$store.state.currentProperty;
      },
      form () {
        return {
          date: this.modalRecord.date,
          amount: this.modalRecord.amount,
          description: this.modalRecord.description,
          category: this.modalRecord.category
        }
      }
    },
    created: function() {
      this.recordList = [];
      this.GetRecords();
    }
  }
</script>

<style scoped>
</style>